import { forwardRef, useImperativeHandle } from 'react';

import { ButtonType } from '@xemplo/button';
import { DawnTriangleAlert } from '@xemplo/icons';
import { Prompt, PromptDialogSlot, usePromptDialog } from '@xemplo/prompt-dialog';
import { Colour } from '@xemplo/style-constants';

import * as S from './modal-styles';
import {
  DeletePayrunApprovalDialogProps,
  PromptDialogRef,
} from './payrun-approvers-detail-modal.types';

export const DeletePrompt = forwardRef<PromptDialogRef, DeletePayrunApprovalDialogProps>(
  (props: Readonly<DeletePayrunApprovalDialogProps>, ref) => {
    const promptDialog = usePromptDialog({
      id: 'delete-payrun-approver-prompt',
    });
    useImperativeHandle(ref, () => promptDialog);

    const { confirmCallback, name } = props;

    const handlePromptConfirm = () => {
      promptDialog.closeDialog();
      confirmCallback?.();
    };

    const onCancel = () => {
      promptDialog.closeDialog();
    };

    return (
      <Prompt.Dialog {...promptDialog.dialogProps}>
        {promptDialog.isOpen ? (
          <Prompt>
            <Prompt.Slot
              name={PromptDialogSlot.Header}
              render={
                <Prompt.Header
                  title="Remove user"
                  icon={<DawnTriangleAlert color={Colour.Red[500]} />}
                />
              }
            />
            <Prompt.Slot
              name={PromptDialogSlot.Body}
              render={
                <Prompt.Body>
                  <S.PromptMessage>
                    Are you sure you want to delete
                    <S.PromptBold> {name}</S.PromptBold>?
                  </S.PromptMessage>
                  <S.PromptMessage>You cannot undo this action.</S.PromptMessage>
                </Prompt.Body>
              }
            />
            <Prompt.Slot
              name={PromptDialogSlot.Footer}
              render={
                <Prompt.Footer
                  btnPrimary={{
                    label: 'Remove',
                    ariaLabel: 'confirm remove approver button',
                    onClick: handlePromptConfirm,
                    type: ButtonType.Destructive,
                  }}
                  btnTertiary={{
                    label: 'Cancel',
                    ariaLabel: 'cancel',
                    type: ButtonType.Tertiary,
                    onClick: onCancel,
                  }}
                />
              }
            />
          </Prompt>
        ) : null}
      </Prompt.Dialog>
    );
  }
);
